import { Card, Form, Select, Button, Row, Col } from "antd";

export default function AccountingContent({
  form,
  onNext,
  onPrevious,
  interbankTemplate,
  assetAccountOptions,
  incomeAccountOptions,
}) {
  const handleInputChange = (field, value) => {
    form.setFieldValue(field, value);
  };

  const handleNext = async () => {
    try {
      await form.validateFields([
        "placementInitiationDebit",
        "placementInitiationCredit",
        "interestAccrualDebit",
        "interestAccrualCredit",
        "interestSettlementDebit",
        "interestSettlementCredit",
        "principalRedemptionDebit",
        "principalRedemptionCredit",
        "interestGLPostingDebit",
        "interestGLPostingCredit",
      ]);
      onNext();
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  return (
    <Card
      style={{
        borderRadius: "12px",
        boxShadow:
          "0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          marginBottom: "32px",
        }}
      >
        <h1
          style={{
            fontWeight: 700,
            fontSize: "24px",
            lineHeight: "32px",
            color: "#101828",
            marginBottom: "0px",
          }}
        >
          Accounting
        </h1>
        <p
          style={{
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "20px",
            color: "#344054",
            marginTop: "0px",
          }}
        >
          Define GL mapping for financial events.
        </p>
      </div>

      <Form layout="vertical" requiredMark={false} form={form}>
        {/* Header Row */}
        <Row
          style={{
            background: "#F9FAFB",
            padding: "12px 24px",
            borderRadius: "8px 8px 0 0",
            marginBottom: "8px",
          }}
        >
          <Col span={8}>
            <span style={{ color: "#344054", fontWeight: 500 }}>Events</span>
          </Col>
          <Col span={8}>
            <span style={{ color: "#344054", fontWeight: 500 }}>Debit</span>
          </Col>
          <Col span={8}>
            <span style={{ color: "#344054", fontWeight: 500 }}>Credit</span>
          </Col>
        </Row>

        {/* Content Rows */}
        <Row style={{ marginBottom: "8px" }}>
          <Col span={8} style={{ padding: "8px 24px" }}>
            <span>Placement Initiation</span>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name="placementInitiationDebit"
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                onChange={(value) =>
                  handleInputChange("placementInitiationDebit", value)
                }
                options={incomeAccountOptions}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name="placementInitiationCredit"
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                onChange={(value) =>
                  handleInputChange("placementInitiationCredit", value)
                }
                options={incomeAccountOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row style={{ marginBottom: "8px" }}>
          <Col span={8} style={{ padding: "8px 24px" }}>
            <span>Interest Accrual</span>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name="interestAccrualDebit"
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                onChange={(value) =>
                  handleInputChange("interestAccrualDebit", value)
                }
                options={assetAccountOptions}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name="interestAccrualCredit"
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                onChange={(value) =>
                  handleInputChange("interestAccrualCredit", value)
                }
                options={assetAccountOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row style={{ marginBottom: "8px" }}>
          <Col span={8} style={{ padding: "8px 24px" }}>
            <span>Interest Settlement (Maturity)</span>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name="interestSettlementDebit"
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                onChange={(value) =>
                  handleInputChange("interestSettlementDebit", value)
                }
                options={assetAccountOptions}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name="interestSettlementCredit"
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                onChange={(value) =>
                  handleInputChange("interestSettlementCredit", value)
                }
                options={assetAccountOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row style={{ marginBottom: "8px" }}>
          <Col span={8} style={{ padding: "8px 24px" }}>
            <span>Principal Redemption</span>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name="principalRedemptionDebit"
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                onChange={(value) =>
                  handleInputChange("principalRedemptionDebit", value)
                }
                options={incomeAccountOptions}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name="principalRedemptionCredit"
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                onChange={(value) =>
                  handleInputChange("principalRedemptionCredit", value)
                }
                options={incomeAccountOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row style={{ marginBottom: "24px" }}>
          <Col span={8} style={{ padding: "8px 24px" }}>
            <span>Interest GL Posting</span>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name="interestGLPostingDebit"
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                onChange={(value) =>
                  handleInputChange("interestGLPostingDebit", value)
                }
                options={assetAccountOptions}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "8px 0" }}>
            <Form.Item
              name="interestGLPostingCredit"
              rules={[
                {
                  required: true,
                  message: "Please select GL",
                },
              ]}
            >
              <Select
                placeholder="Select GL Account"
                style={{ width: "90%", height: "44px" }}
                onChange={(value) =>
                  handleInputChange("interestGLPostingCredit", value)
                }
                options={assetAccountOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "32px",
            gap: "12px",
          }}
        >
          <Button style={{ height: "44px" }} onClick={onPrevious}>
            Previous
          </Button>
          <Button
            type="primary"
            style={{ backgroundColor: "#9F1AB1", height: "44px" }}
            onClick={handleNext}
          >
            Next - Counterparty settings
          </Button>
        </div>
      </Form>
    </Card>
  );
}
